module.exports = __webpack_public_path__ + "static/media/trigon-hotels.351cd0cf.jpg";